module.exports = __webpack_public_path__ + "static/idea-a9af5feeab3d557e0257034d25966b61.jpg";